import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { LoaderRingType, LoaderRingWidthOrHeight } from '@design-system/components/atoms/loader-ring/entities/loader-ring.types';

@Component({
  selector: 'app-ds-loader-ring',
  templateUrl: './loader-ring.component.html',
  styleUrls: ['./loader-ring.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class LoaderRingDsComponent {

  @Input() type = LoaderRingType.Primary;
  @Input() size: LoaderRingWidthOrHeight = 'var(--typography-font-size-24)';

  constructor() { }

}
